import React, { useEffect } from 'react';
import Routes from './routes/Routes';
import { ConnectedRouter } from 'connected-react-router';
import { Switch } from 'react-router-dom';
import { history } from './redux';
import moment from 'moment';

import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'moment/locale/fr-ca';
import 'moment/locale/en-ca';
import './App.css';

import AppWrapper from './@jumbo/components/AppWrapper';
import AppContextProvider from './@jumbo/components/contextProvider/AppContextProvider';

import i18n from './i18n';
import axios from 'axios';
import { SnackbarProvider } from 'notistack';
import SnackbarNotification from '@acnb/CustomComponents/SnackbarNotification/SnackbarNotification';
import { localeStorageLanguageKey } from 'config/config';

const App = () => {
  useEffect(() => {
    let language = localStorage.getItem(localeStorageLanguageKey) || 'fr';

    i18n.changeLanguage(language);
    axios.defaults.headers.common['Accept-Language'] = language;
    if (language === 'fr') moment.locale('fr-CA');
    else moment.locale('en-CA');

    //i18n.changeLanguage("en");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SnackbarProvider maxSnack={5}>
      <SnackbarNotification />
      <ConnectedRouter history={history}>
        <AppContextProvider>
          <AppWrapper>
            <Switch>
              <Routes />
            </Switch>
          </AppWrapper>
        </AppContextProvider>
      </ConnectedRouter>
    </SnackbarProvider>
  );
};

export default App;
